<template>
  <div>
    <div class="class-assigned-section">
      <!-- TITLE -->
      <div class="page-title font-weight-bold color_text">Assigned Classes</div>

      <!-- CLASS BRANCH ROW -->
      <div
        class="class-branch-row d-flex justify-content-start align-items-start flex-wrap"
      >
        <ClassBranch
          :class_id="Number(item.id)"
          :class_name="item.class_name"
          :class_subject="item.subjects"
          branch_type="subject"
          :show_option="true"
          v-for="(item, index) in classes"
          :key="index"
          @assign-subject="$emit('assign-teacher-subject', $event)"
          @remove-subject="$emit('remove-teacher-subject', $event)"
        ></ClassBranch>
      </div>

      <div
        class="show-more position-relative"
        style="top: -40px; margin-bottom: -30px"
      >
        <div
          @click="$emit('assign-to-class')"
          class="btn-link font-weight-bold"
        >
          <span v-if="classes.length === 0">Assign to Class</span>
          <span v-else>Assign to another Class</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ClassAssigned",

  components: {
    ClassBranch: () =>
      import(
        /* webpackChunkName: "classbranch" */ "@/components/schoolComps/dashboard/home/ClassBranch"
      ),
  },

  props: {
    classes: Array,
  },
};
</script>

<style lang="scss">
.class-assigned-section {
  margin-bottom: 30px;

  .page-title {
    @include breakpoint_max(sm) {
      font-size: 15.5px !important;
    }
  }

  .class-branch-row {
    width: 100%;
    @include breakpoint_min_max(320, 399) {
      overflow: auto;
      flex-flow: row nowrap !important;
    }
  }

  .show-more {
    .btn-link {
      @include breakpoint_max(sm) {
        font-size: 12px;
        // font-weight: 500 !important;
      }
    }
  }
}
</style>
